'use strict';

var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _createClass = require('@babel/runtime/helpers/createClass');
var _inherits = require('@babel/runtime/helpers/inherits');
var _possibleConstructorReturn = require('@babel/runtime/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime/helpers/getPrototypeOf');
var React = require('react');
var injectSheet = require('react-jss');
var THEME = require('pobble-components/dist/theme');
var classNames = require('classnames');
var PropTypes = require('prop-types');
var Spinner = require('pobble-components/dist/spinner');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var faCaretLeft = require('@fortawesome/pro-solid-svg-icons/faCaretLeft');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var THEME__default = /*#__PURE__*/_interopDefaultLegacy(THEME);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var Spinner__default = /*#__PURE__*/_interopDefaultLegacy(Spinner);

var COLORS = THEME__default["default"].COLORS;
var styles = {
  button: {
    alignItems: 'center',
    fontWeight: 'bold',
    outline: 'none',
    textDecoration: 'none',
    display: 'inline-flex',
    borderRadius: '4px',
    border: "1px solid ".concat(COLORS.BLUE.NORMAL),
    backgroundColor: COLORS.BLUE.NORMAL,
    height: '30px',
    cursor: 'pointer',
    fontSize: '14px',
    lineHeight: '14px',
    padding: '7px 10px',
    color: '#fff',
    transition: 'background-color .1s ease-in-out, color .1s ease-in-out',
    '&:hover': {
      backgroundColor: COLORS.BLUE.EXTRA_FADED
    },
    '&:active': {
      boxShadow: "0 0 2px 1px ".concat(COLORS.BLUE.EXTRA_FADED)
    }
  },
  darkBlue: {
    background: 'var(--dark-blue)',
    border: 'none',
    color: '#fff',
    '&:hover, &:focus': {
      background: 'var(--dark-blue-)'
    },
    '&$disabled': {
      opacity: '.3',
      backgroundColor: 'var(--dark-blue)',
      color: '#fff'
    },
    '&$simple': {
      color: 'var(--dark-blue)',
      '&:hover, &:focus': {
        color: 'var(--dark-blue-)'
      }
    }
  },
  minw: {
    minWidth: '100px',
    justifyContent: 'center'
  },
  spinner: {
    fontSize: '.8em',
    color: 'currentColor'
  },
  iconHolder: {
    height: '10px',
    margin: '0 5px 0 0',
    '& > svg': {
      width: 'auto',
      height: '100%',
      display: 'block'
    }
  },
  equalizer: {
    width: '10px',
    height: '10px',
    marginLeft: '5px'
  },
  back: {
    '& $iconHolder': {
      height: '14px',
      display: 'flex',
      justifyContent: 'flex-end'
    }
  },
  buttonTall: {
    height: '40px',
    padding: '12px 15px',
    '& $iconHolder': {
      height: '12px',
      margin: '0 6px 0 -2px'
    }
  },
  big: {
    height: '50px',
    padding: '15px 20px',
    fontSize: '20px',
    lineHeight: '20px',
    '& $iconHolder': {
      height: '14px',
      margin: '0 6px 0 -4px'
    }
  },
  green: {
    border: "1px solid ".concat(COLORS.GREEN.NORMAL),
    backgroundColor: COLORS.GREEN.NORMAL,
    '&:hover': {
      backgroundColor: COLORS.GREEN.FADED
    },
    '&:active': {
      boxShadow: "0 0 2px 1px ".concat(COLORS.GREEN.EXTRA_FADED)
    },
    '&$secondary': {
      color: COLORS.GREEN.NORMAL,
      '&:hover': {
        color: '#fff'
      }
    },
    '&$simple': {
      color: COLORS.GREEN.NORMAL,
      '&:hover': {
        color: COLORS.GREEN.FADED
      },
      '&:active': {
        color: COLORS.GREEN.NORMAL
      }
    }
  },
  white: {
    border: 'none',
    backgroundColor: 'var(--light-gray--)',
    color: 'var(--gray)',
    transition: 'none',
    '&:hover': {
      backgroundColor: '#fff'
    },
    '&:active': {},
    '&$secondary': {
      color: 'var(--light-gray--)',
      background: 'none',
      border: '1px solid var(--light-gray--)',
      '&:hover': {
        background: 'rgba(255, 255, 255, .05)',
        color: 'var(--light-gray--)'
      }
    },
    '&$simple': {
      color: 'var(--light-gray--)',
      '&:hover': {
        color: 'var(--light-gray--)'
      },
      '&:active': {
        color: 'var(--light-gray--)'
      }
    }
  },
  purple: {
    border: "1px solid var(--purple)",
    backgroundColor: 'var(--purple)',
    '&:hover': {
      backgroundColor: 'var(--purple-)'
    },
    '&:active': {
      boxShadow: "0 0 2px 1px var(--purple--)"
    },
    '&$secondary': {
      color: 'var(--purple)',
      '&:hover': {
        color: '#fff'
      }
    },
    '&$simple': {
      color: 'var(--purple)',
      '&:hover': {
        color: 'var(--purple-)'
      },
      '&:active': {
        color: 'var(--purple)'
      }
    }
  },
  secondary: {
    backgroundColor: '#fff',
    color: COLORS.BLUE.NORMAL,
    '&:hover': {
      color: '#fff'
    }
  },
  danger: {
    borderColor: COLORS.RED.FADED,
    backgroundColor: COLORS.RED.FADED,
    '&:hover': {
      backgroundColor: COLORS.RED.EXTRA_FADED
    },
    '&$simple': {
      color: COLORS.RED.FADED,
      '&:hover': {
        color: COLORS.RED.EXTRA_FADED
      },
      '&:active': {
        color: COLORS.RED.FADED
      }
    }
  },
  dangerSecondary: {
    borderColor: COLORS.RED.EXTRA_FADED,
    backgroundColor: '#fff',
    color: COLORS.RED.FADED,
    '&:hover': {
      backgroundColor: '#fff',
      borderColor: COLORS.RED.NORMAL,
      color: COLORS.RED.NORMAL
    }
  },
  success: {
    borderColor: COLORS.GREEN.FADED,
    backgroundColor: COLORS.GREEN.FADED,
    '&:hover': {
      backgroundColor: COLORS.GREEN.EXTRA_FADED
    }
  },
  successSecondary: {
    borderColor: COLORS.GREEN.EXTRA_FADED,
    backgroundColor: '#fff',
    color: COLORS.GREEN.FADED,
    '&:hover': {
      backgroundColor: '#fff',
      borderColor: COLORS.GREEN.NORMAL,
      color: COLORS.GREEN.NORMAL
    }
  },
  warning: {
    borderColor: COLORS.ALERT.WARNING.FADED,
    backgroundColor: COLORS.ALERT.WARNING.FADED,
    '&:hover': {
      backgroundColor: COLORS.ALERT.WARNING.EXTRA_FADED
    }
  },
  warningSecondary: {
    borderColor: COLORS.ALERT.WARNING.EXTRA_FADED,
    backgroundColor: '#fff',
    color: COLORS.ALERT.WARNING.FADED,
    '&:hover': {
      backgroundColor: '#fff',
      borderColor: COLORS.ALERT.WARNING.NORMAL,
      color: COLORS.ALERT.WARNING.NORMAL
    }
  },
  disabled: {
    backgroundColor: '#f9f9f9',
    borderColor: '#dedede',
    color: '#cbcbcb',
    cursor: 'not-allowed',
    pointerEvents: 'none',
    '&:hover': {
      backgroundColor: '#f9f9f9',
      borderColor: '#dedede',
      color: '#cbcbcb'
    }
  },
  wide: {
    width: '100%',
    justifyContent: 'center'
  },
  alignLeft: {
    justifyContent: 'flex-start'
  },
  alignRight: {
    justifyContent: 'flex-end'
  },
  alignCenter: {
    justifyContent: 'center'
  },
  simple: {
    color: COLORS.BLUE.NORMAL,
    width: 'auto',
    background: 'none',
    border: 'none',
    '&:hover': {
      background: 'none',
      color: COLORS.BLUE.FADED
    },
    '&:active': {
      boxShadow: 'none',
      color: COLORS.BLUE.NORMAL,
      transition: 'none'
    },
    '&$disabled': {
      color: '#cbcbcb'
    },
    '&$dangerSecondary': {
      color: COLORS.RED.FADED,
      '&:hover': {
        color: COLORS.RED.NORMAL
      }
    }
  },
  tertiary: {
    color: 'var(--gray--)',
    width: 'auto',
    background: 'none',
    border: 'none',
    '&:hover': {
      background: 'none',
      color: 'var(--gray-)'
    },
    '&:active': {
      boxShadow: 'none',
      color: 'var(--gray-)',
      transition: 'none'
    },
    '&$disabled': {
      color: '#cbcbcb'
    }
  },
  bleed: {
    paddingRight: '0',
    paddingLeft: '0'
  }
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Button = /*#__PURE__*/function (_Component) {
  _inherits__default["default"](Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    _classCallCheck__default["default"](this, Button);

    return _super.apply(this, arguments);
  }

  _createClass__default["default"](Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          as = _this$props.as,
          green = _this$props.green,
          darkBlue = _this$props.darkBlue,
          white = _this$props.white,
          purple = _this$props.purple,
          classes = _this$props.classes,
          children = _this$props.children,
          secondary = _this$props.secondary,
          danger = _this$props.danger,
          onClick = _this$props.onClick,
          dangerSecondary = _this$props.dangerSecondary,
          success = _this$props.success,
          successSecondary = _this$props.successSecondary,
          warning = _this$props.warning,
          warningSecondary = _this$props.warningSecondary,
          tall = _this$props.tall,
          big = _this$props.big,
          disabled = _this$props.disabled,
          action = _this$props.action,
          href = _this$props.href,
          _blank = _this$props._blank,
          wide = _this$props.wide,
          className = _this$props.className,
          nodeRef = _this$props.nodeRef,
          simple = _this$props.simple,
          tertiary = _this$props.tertiary,
          type = _this$props.type,
          span = _this$props.span,
          style = _this$props.style,
          icon = _this$props.icon,
          alignLeft = _this$props.alignLeft,
          alignRight = _this$props.alignRight,
          alignCenter = _this$props.alignCenter,
          bleed = _this$props.bleed,
          pending = _this$props.pending,
          back = _this$props.back,
          minw = _this$props.minw,
          to = _this$props.to;
      var buttonIcon = !back ? icon : /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: faCaretLeft.faCaretLeft
      });
      var Component = as ? as : href ? 'a' : span ? 'span' : 'button';
      var additionalProps = Component === 'button' ? {
        type: type || 'button'
      } : null;
      return /*#__PURE__*/React__default["default"].createElement(Component, _extends__default["default"]({
        to: to,
        style: style,
        disabled: disabled || pending,
        ref: nodeRef,
        target: _blank && '_blank',
        href: !disabled && href ? href : undefined,
        className: classNames__default["default"](classes.button, className, _defineProperty__default["default"]({}, classes.buttonTall, tall), _defineProperty__default["default"]({}, classes.big, big), _defineProperty__default["default"]({}, classes.secondary, secondary), _defineProperty__default["default"]({}, classes.danger, danger), _defineProperty__default["default"]({}, classes.success, success), _defineProperty__default["default"]({}, classes.warning, warning), _defineProperty__default["default"]({}, classes.disabled, disabled), _defineProperty__default["default"]({}, classes.wide, wide), _defineProperty__default["default"]({}, classes.dangerSecondary, dangerSecondary), _defineProperty__default["default"]({}, classes.successSecondary, successSecondary), _defineProperty__default["default"]({}, classes.warningSecondary, warningSecondary), _defineProperty__default["default"]({}, classes.simple, simple), _defineProperty__default["default"]({}, classes.alignLeft, alignLeft), _defineProperty__default["default"]({}, classes.alignRight, alignRight), _defineProperty__default["default"]({}, classes.alignCenter, alignCenter), _defineProperty__default["default"]({}, classes.bleed, bleed), _defineProperty__default["default"]({}, classes.green, green), _defineProperty__default["default"]({}, classes.darkBlue, darkBlue), _defineProperty__default["default"]({}, classes.white, white), _defineProperty__default["default"]({}, classes.purple, purple), _defineProperty__default["default"]({}, classes.back, back), _defineProperty__default["default"]({}, classes.tertiary, tertiary), _defineProperty__default["default"]({}, classes.minw, minw)),
        onClick: action || onClick
      }, additionalProps), !!buttonIcon && !pending && /*#__PURE__*/React__default["default"].createElement("div", {
        className: classes.iconHolder
      }, buttonIcon), pending && /*#__PURE__*/React__default["default"].createElement("div", {
        className: classes.iconHolder
      }, /*#__PURE__*/React__default["default"].createElement(Spinner__default["default"], {
        className: classes.spinner
      })), children);
    }
  }]);

  return Button;
}(React.Component);

Button.propTypes = {
  /** Makes button taller */
  tall: PropTypes__default["default"].bool,

  /** Applies secondary theme to the button */
  secondary: PropTypes__default["default"].bool,

  /** Applies danger theme to the button */
  danger: PropTypes__default["default"].bool,

  /** Applies danger secondary theme to the button */
  dangerSecondary: PropTypes__default["default"].bool,

  /** Applies success theme to the button */
  success: PropTypes__default["default"].bool,

  /** Applies success secondary theme to the button */
  successSecondary: PropTypes__default["default"].bool,

  /** Applies warning theme to the button */
  warning: PropTypes__default["default"].bool,

  /** Applies danger secondary theme to the button */
  warningSecondary: PropTypes__default["default"].bool,

  /** Disables button */
  disabled: PropTypes__default["default"].bool,

  /** Click handler for the button */
  action: PropTypes__default["default"].func,

  /** This prop will make your button a link pointing to this url */
  href: PropTypes__default["default"].string,

  /** In case you specified href this prop will make your url to open in a new tab */
  _blank: PropTypes__default["default"].bool,

  /** Makes full width button */
  wide: PropTypes__default["default"].bool,

  /** Add your own classname to the button  */
  className: PropTypes__default["default"].string,

  /** Restyle button */
  style: PropTypes__default["default"].object,

  /** Node reference */
  nodeRef: PropTypes__default["default"].func,

  /** Apply simple theme to button */
  simple: PropTypes__default["default"].bool,

  /** By default Button will render button component. You can specify type of the button with this prop */
  type: PropTypes__default["default"].string,

  /** Icon on the left */
  icon: PropTypes__default["default"].oneOfType([PropTypes__default["default"].node, PropTypes__default["default"].string])
};
Button.defaultProps = {
  tall: false,
  secondary: false,
  danger: false,
  dangerSecondary: false,
  success: false,
  successSecondary: false,
  warning: false,
  warningSecondary: false,
  disabled: false,
  wide: false,
  simple: false
};
var index = injectSheet__default["default"](styles)(Button);

module.exports = index;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src2416834937/src/pobble-app/client/~/pobble-components/dist/button/index.js